export default {
  eyebrow: 'Partnerportal',
  title: 'Branding',
  description: 'Udseendet af din white-label-portal og loginside.',
  page: {
    read_only_notice: 'Skrivebeskyttet. Klik på Rediger for at ændre værdier.',
    editing_notice: 'Redigerer — ændringer er synlige for dit team og dine kunder.',
  },
  branding: {
    scope_hint:
      'Gælder for din white-label-portal og loginside — ikke dine restauranters webshops, som er brandet pr. restaurant.',
    upload: 'Upload logo',
    logo: {
      label: 'Logo',
      hint: 'Vises på dine white-label-flader.',
    },
    circle_logo: {
      label: 'Favicon / rundt logo',
      hint: 'Firkantet logo, der bruges som favicon og avatar. Valgfrit — kan fjernes.',
    },
    splash_image: {
      label: 'Login-billede',
      hint: 'Vises på din white-label-loginside. Anbefalet: mindst 1200 px bredt. Valgfrit – kan fjernes.',
    },
    footer_note: 'Flere brandingmuligheder (sekundære farver) kommer senere.',
  },
  form: {
    primary_color: {
      label: 'Primær brandfarve',
      hint: 'Giver din partnerportal og dit login dit tema.',
    },
    dashboard_subdomain: {
      label: 'Partnerens login-slug',
      hint: 'Slug med små bogstaver – identificerer dit brand i teamets login-link (?partner=…).',
      placeholder: 'partnernavn',
    },
    login_url: {
      label: 'Teamets login-link',
      hint: 'Del dette link med dit team – det åbner loginsiden med dit brand.',
    },
    file: {
      label: 'Billede',
    },
  },
  login_url_warning: {
    title: 'Skift dit teams login-link?',
    description:
      'Dit teams login-link ændres til {{url}}. Del det nye link fremover – det gamle viser ikke længere dit brand.',
    description_no_url:
      'Dit teams login-link ændres. Del det nye link fremover – det gamle viser ikke længere dit brand.',
  },
  login_url_changed: {
    title: 'Teamets login-link er ændret',
    description: 'Dit team logger nu ind på {{url}}. Gem det nye link som bogmærke, og del det med dit team.',
  },
  buttons: {
    edit: 'Rediger',
    cancel: 'Annuller',
    save: 'Gem',
  },
  toasts: {
    load_error: 'Din branding kunne ikke indlæses.',
    failed_to_save_changes: 'Ændringerne kunne ikke gemmes',
    changes_got_saved: 'Ændringerne er gemt',
    logo_uploaded: 'Logo uploadet',
    logo_upload_failed: 'Logoet kunne ikke uploades',
    logo_removed: 'Logo fjernet',
    logo_remove_failed: 'Logoet kunne ikke fjernes',
    file_too_large: 'Filen er for stor. Maksimal størrelse er {{max}} MB.',
    image_too_narrow: 'Login-billedet skal være mindst {{min}} px bredt.',
  },
};
